function DefaultCompanyCover(company){

    if(!company) return '/img/cover_placeholder.png';

    if(company.cover_picture){
        return process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + company.cover_picture;
    }

    const projects = company.projects || [];

    for(let i = 0; i < projects.length; i++){
        const project = projects[i];

        if(!project.medias){
            continue;
        }

        for(let j = 0; j < project.medias.length; j++){
            const media = project.medias[j];

            if(media.type.includes("image")){
                return process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + media.path;
            }
        }
    }

    return '/img/cover_placeholder.png';;
}

export default DefaultCompanyCover;